module.exports = __webpack_public_path__ + "static/media/2.01e3e241.JPG";